/**
 * App locale roster — instantiates the pure engine from @scrawlr/lib-js-i18n
 * with this app's supported locales, and re-exports the build-safe helpers under
 * their original names. This is the single place the app declares its locales to
 * the engine. `locale-config.js` (the app barrel) re-exports these plus the
 * app-specific data (labels, host policy, Stripe mapping).
 */
import { createLocaleConfig } from '@scrawlr/lib-js-i18n'

const {
    DEFAULT_LOCALE,
    SUPPORTED_LOCALE_CODES,
    SUPPORTED_LOCALES,
    isLocaleSegment,
    normalizeLocale,
} = createLocaleConfig({
    defaultLocale: 'en',
    languageToLocaleMap: {
        en: 'en',
        es: 'es-mx',
        fr: 'fr-ca',
    },
    // Set iteration order is insertion order and is relied on by sitemap/route
    // generation, so keep 'en' first.
    supportedLocaleCodes: [
        'en',
        'fr-ca',
        'es-mx',
    ],
})

export {
    DEFAULT_LOCALE,
    isLocaleSegment,
    normalizeLocale,
    SUPPORTED_LOCALE_CODES,
    SUPPORTED_LOCALES,
}
export {
    isExternalPath,
    isProtocolPath,
} from '@scrawlr/lib-js-i18n'
